import { generateCsvDownload } from '../lib/csv';
import { getRounded } from '../lib/numbers';
import { destroy, post } from '../lib/api';

export function downloadCleanYieldCsv(
  growerId,
  year,
  cleanYield,
  selectedFields,
) {
  const filename = `yield-export-${year}-${growerId}.csv`;

  let csvArr = cleanYield;
  if (selectedFields && selectedFields.length > 0) {
    const selectedAAIDs = selectedFields
      ? selectedFields.map((aaid) => aaid)
      : [];
    csvArr = cleanYield.filter((f) => selectedAAIDs.includes(f.aaid));
  }

  const csvData = csvArr.map((f) => ({
    field_name: f.fieldName,
    farm_name: f.farmName,
    field_id: f.fieldId,
    acres: getRounded(f.acres, 2),
    crop: f.harvestedCrop,
    coverage: f.coverage,
    status: f.status,
    bu_avg: f.avgYield,
    bu_min: f.minYield,
    bu_max: f.maxYield,
    aaid: f.aaid,
  }));

  generateCsvDownload(csvData, filename);
}

export function remove(growerId, year, aaids, rawFiles = []) {
  return destroy(`/growers/${growerId}/yield/${year}`, { aaids, rawFiles });
}

export function findRawFiles(growerId, year, aaids) {
  return post(`/growers/${growerId}/yield/${year}/raw-files`, aaids);
}
